import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.scss';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation(['resources']);
    return (
        <footer className="page-footer">
            <div className="footer-content">
                <div className="container-fluid">
                    <div style={{ color: 'white' }}>
                        <div className="mb-0" style={{ lineHeight: '40px' }}>                            
                            {t('Rights')}
                            {currentYear}
                            {t('Rights2')} 
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
